// eslint-disable-next-line no-process-env
const version = process.env.VERSION;

module.exports = {
  version,
  api: {
    url: `/api/${version}`,
    endpoints: {
      products: {
        list: 'products/list',
      },
    },
  },
  storageKeys: {
    requests: 'app-requests',
  },
};
